import Confirm from './Confirm.vue'
import Alert from './Alert.vue'

const Plugin = (Vue, options = {}) => {
  const property = options.property || '$dialog'
  delete options.property
  const vuetify = options.vuetify
  delete options.vuetify
  if (!vuetify) {
    console.warn('Plugins dialog needs vuetify instance. Use Vue.use(Dialog, { vuetify })')
  }
  const ConfirmCtor = Vue.extend(Object.assign({
    vuetify
  }, Confirm))
  const AlertCtor = Vue.extend(Object.assign({
    vuetify
  }, Alert))

  const createDialogCmp = (Ctor, options) => {
    const container = document.querySelector('#app > .v-application--wrap') || document.body
    return new Promise(resolve => {
      const cmp = new Ctor(Object.assign({}, {
        propsData: Object.assign({}, Vue.prototype.$dialog.options, options),
        destroyed: () => {
          container.removeChild(cmp.$el)
          resolve(cmp.value)
        }
      }))
      container.appendChild(cmp.$mount().$el)
    })
  }

  const showConfirm = (message, options = {}) => {
    options = Object.assign({}, options)
    options.message = message
    return new Promise((resolve, reject) => {
      options.promiseResolver = resolve
      options.promiseRejecter = reject
      return createDialogCmp(ConfirmCtor, options)
    })
  }

  const showAlert = (message, options = {}) => {
    options = Object.assign({}, options)
    options.message = message
    const types = ['error', 'warning', 'info']
    if (!options.type || !types.includes(options.type)) {
      options.type = 'error'
    }
    return createDialogCmp(AlertCtor, options)
  }

  Vue.prototype[property] = {}
  Vue.prototype[property].confirm = showConfirm
  Vue.prototype[property].alert = showAlert
  Vue.prototype[property].options = options || {}
}

export default Plugin
